import { AccessActions } from "../actions";

const initialState = {
  accesses: {
    rows: [],
    rowCount: 1,
    pageCount: 1,
  },
  access: null,
};

export default function access(state = initialState, action) {
  switch (action.type) {
    case AccessActions.ACTION_SAVE_ACCESS_CONSOLIDATED:
      return {
        ...state,
        accesses: action.payload,
      };
    case AccessActions.ACTION_SAVE_TOTAL_ACCESS_CONSOLIDATED:
      return {
        ...state,
        totalAccess: action.payload,
      };
    case AccessActions.ACTION_SAVE_TOTAL_HASH_AGENCY:
      return {
        ...state,
        accesses: action.payload,
      };
    default:
      return state;
  }
}

export function getAccesses(state) {
  return state.access.accesses;
}

export function getTotalAccesses(state) {
  return state.access.totalAccess;
}
